import { formatDistanceStrict, parseISO } from 'date-fns';

export const relativeDateString = (dateToCompare: Date | number | string) => {
  let date = dateToCompare;
  if (typeof date === 'string') {
    date = parseISO(dateToCompare as string);
  }
  return date && formatDistanceStrict(date, Date.now(), { roundingMethod: 'round' });
};
